import { Component } from '@angular/core';

@Component({
  selector: 'stars-guest-teacher-resources',
  templateUrl: './guest-teacher-resources.component.html',
  styleUrls: ['./guest-teacher-resources.component.scss']
})
export class GuestTeacherResourcesComponent {}
